<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font"
            >Middleman管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="item_font">规则配置</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>

      <div>
        <el-button
          type="text"
          size="mini"
          style="margin-right: 12px; color: orangered"
          >请先选择科室</el-button
        >
        <el-select
          v-model="department"
          size="mini"
          placeholder="请选择科室"
          @change="changeDep"
          style="margin-right: 12px"
        >
          <el-option
            v-for="(item, index) in departmentList"
            :key="index"
            :label="item.name"
            :value="item.depType"
          ></el-option>
        </el-select>
      </div>

      <div style="width: 660px; margin: 30px auto" class="item_font">
        <el-form
          id="selectForm"
          label-position="right"
          label-width="200px"
          :model="form"
          ref="form"
          :rules="formRules"
        >
          <el-form-item prop="firstReplyTime" label="首次回消息时间:">
            <el-col :span="6">
              <el-input v-model.number="form.firstReplyTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位:秒，默认{{
                  rangeValData.firstReplyTime.defVal
                }}，范围：{{ rangeValData.firstReplyTime.minVal }}~{{
                  rangeValData.firstReplyTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="机器人返回的话术按分隔符分隔，分隔的第一句话术称为“首句”，回复首句的等待时间称为“首次回消息时间(秒)”。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="typewriteTime" label="每个字打字时间:">
            <el-col :span="6">
              <el-input v-model.number="form.typewriteTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位:毫秒，默认{{
                  rangeValData.typewriteTime.defVal
                }}，范围：{{ rangeValData.typewriteTime.minVal }}~{{
                  rangeValData.typewriteTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="客服输入框中输入的单个字所花的时间(毫秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="nomouthIdleTime" label="未开口空闲检测时间:">
            <el-col :span="6">
              <el-input v-model.number="form.nomouthIdleTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.nomouthIdleTime.defVal
                }}，范围：{{ rangeValData.nomouthIdleTime.minVal }}~{{
                  rangeValData.nomouthIdleTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="未开口客户开口话术回复的间隔时间（间隔时间=未开口空闲检测时间+次数*空闲增量时间）(秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="nomouthIdleNum" label="未开口空闲检测次数:">
            <el-col :span="6">
              <el-input v-model.number="form.nomouthIdleNum"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.nomouthIdleNum.defVal
                }}，范围：{{ rangeValData.nomouthIdleNum.minVal }}~{{
                  rangeValData.nomouthIdleNum.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="未开口客户开口话术回复的次数。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="omouthIdleTime" label="开口空闲检测时间:">
            <el-col :span="6">
              <el-input v-model.number="form.omouthIdleTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.omouthIdleTime.defVal
                }}，范围：{{ rangeValData.omouthIdleTime.minVal }}~{{
                  rangeValData.omouthIdleTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="开口客户一段时间未说话后，激活空闲检查到回复客户话术的时间(秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="omouthIdleNum" label="开口空闲检测次数:">
            <el-col :span="6">
              <el-input v-model.number="form.omouthIdleNum"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.omouthIdleNum.defVal
                }}，范围：{{ rangeValData.omouthIdleNum.minVal }}~{{
                  rangeValData.omouthIdleNum.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="开口后客户会话空闲检查的次数。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>
          <el-form-item prop="idleIncrementTime" label="空闲次数增量时间:">
            <el-col :span="6">
              <el-input v-model.number="form.idleIncrementTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.idleIncrementTime.defVal
                }}，范围：{{ rangeValData.idleIncrementTime.minVal }}~{{
                  rangeValData.idleIncrementTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="空闲次数每次增加后增加的话术回复时间(秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item
            prop="nomouthReplyTimeMode"
            label="未开口多条话术回复时间模式:"
          >
            <el-col :span="6">
              <!-- <el-input v-model.number=""></el-input> -->
              <el-select v-model="form.nomouthReplyTimeMode">
                <el-option
                  v-for="(item1, index1) in rangeValData.nomouthReplyTimeMode
                    .vals"
                  :key="index1"
                  :label="item1.name"
                  :value="item1.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(默认{{ rangeValData.nomouthReplyTimeMode.defVal.name }})</span
              >
              <el-tooltip
                effect="dark"
                content="未开口多条话术回复时间模式(fixed：固定，typewrite：打字计算)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item
            prop="nomouthFixedReplyTime"
            label="未开口多条话术回复时间:"
          >
            <el-col :span="6">
              <el-input v-model.number="form.nomouthFixedReplyTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.nomouthFixedReplyTime.defVal
                }}，范围：{{ rangeValData.nomouthFixedReplyTime.minVal }}~{{
                  rangeValData.nomouthFixedReplyTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="未开口多条话术回复时间（第1条话术后回复间隔）。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="replyMinTime" label="话术回复最小时间:">
            <el-col :span="6">
              <el-input v-model.number="form.replyMinTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  rangeValData.replyExtremum.defVal
                }}，范围：{{ rangeValData.replyExtremum.minVal }}~{{
                  rangeValData.replyExtremum.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="话术回复最小时间。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="replyMaxTime" label="话术回复最大时间:">
            <el-col :span="6">
              <el-input v-model.number="form.replyMaxTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：毫秒，默认{{
                  rangeValData.replyExtremum.defVal
                }}，范围：{{ rangeValData.replyExtremum.minVal }}~{{
                  rangeValData.replyExtremum.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="话术回复最大时间。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item
            prop="noopenFixedReply"
            label="未开口多条话术回复时间模式:"
          >
            <el-col :span="6">
              <!-- <el-input v-model.number=""></el-input> -->
              <el-select v-model="form.noopenFixedReply">
                <el-option
                  v-for="(item2, index2) in rangeValData.noopenFixedReply.vals"
                  :key="index2"
                  :label="item2.name"
                  :value="item2.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(默认{{ rangeValData.noopenFixedReply.defVal.name }})</span
              >
              <el-tooltip
                effect="dark"
                content="未开口固定回复开关（enable：开启，disable：关闭）。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item
            prop="nomouthFixedReplyTimeList"
            label="未开口固定回复时间列表:"
          >
            <el-col :span="6">
              <el-input
                :disabled="form.noopenFixedReply == 'disable'"
                v-model="form.nomouthFixedReplyTimeList"
              ></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：秒，默认{{
                  String(rangeValData.nomouthFixedReplyTimeList)
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="未开口固定回复时间列表（noopenFixedReply=enable时，设置）。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="utterReplyMode" label="话术回复模式:">
            <el-col :span="6">
              <!-- <el-input v-model.number=""></el-input> -->
              <el-select v-model="form.utterReplyMode">
                <el-option
                  v-for="(item3, index3) in rangeValData.utterReplyMode.vals"
                  :key="index3"
                  :label="item3.name"
                  :value="item3.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(默认{{ rangeValData.utterReplyMode.defVal.name }})</span
              >
              <el-tooltip
                effect="dark"
                content="话术回复模式。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>

          <el-form-item prop="openedFirstReplyTime" label="开口后首句回复时间:">
            <el-col :span="6">
              <el-input v-model.number="form.openedFirstReplyTime"></el-input>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px"
                >(单位：毫秒，默认{{
                  rangeValData.openedFirstReplyTime.defVal
                }}，范围：{{ rangeValData.openedFirstReplyTime.minVal }}~{{
                  rangeValData.openedFirstReplyTime.maxVal
                }})</span
              >
              <el-tooltip
                effect="dark"
                content="开口后首句回复时间。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>
          <!-- <el-form-item prop="openedFirstReplyTime" label="未开口前分配:">
            <el-col :span="6">
              <el-switch
                v-model="form.allocateBeforeOpening"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-col>
            <el-col :span="18">
              <span style="margin-left: 10px">（默认开启）</span>
              <el-tooltip
                effect="dark"
                content="默认开启"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item> -->
          <el-form-item style="margin-top: 60px">
            <el-button
              type="primary"
              @click="setRulesRequest('form')"
              class="item_font"
              >修改配置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    var validateFirstReplyTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.firstReplyTime.minVal ||
        value > this.rangeValData.firstReplyTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.firstReplyTime.minVal +
              "~" +
              this.rangeValData.firstReplyTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateTypewriteTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.typewriteTime.minVal ||
        value > this.rangeValData.typewriteTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.typewriteTime.minVal +
              "~" +
              this.rangeValData.typewriteTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };
    var validatenomouthIdleTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.nomouthIdleTime.minVal ||
        value > this.rangeValData.nomouthIdleTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.nomouthIdleTime.minVal +
              "~" +
              this.rangeValData.nomouthIdleTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateNomouthIdleNum = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.nomouthIdleNum.minVal ||
        value > this.rangeValData.nomouthIdleNum.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.nomouthIdleNum.minVal +
              "~" +
              this.rangeValData.nomouthIdleNum.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateOmouthIdleTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.omouthIdleTime.minVal ||
        value > this.rangeValData.omouthIdleTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.omouthIdleTime.minVal +
              "~" +
              this.rangeValData.omouthIdleTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateOmouthIdleNum = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.omouthIdleNum.minVal ||
        value > this.rangeValData.omouthIdleNum.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.omouthIdleNum.minVal +
              "~" +
              this.rangeValData.omouthIdleNum.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateIdleIncrementTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.idleIncrementTime.minVal ||
        value > this.rangeValData.idleIncrementTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.idleIncrementTime.minVal +
              "~" +
              this.rangeValData.idleIncrementTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateNomouthFixedReplyTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.nomouthFixedReplyTime.minVal ||
        value > this.rangeValData.nomouthFixedReplyTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.nomouthFixedReplyTime.minVal +
              "~" +
              this.rangeValData.nomouthFixedReplyTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateIdleReplyMinTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.replyExtremum.minVal ||
        value > this.rangeValData.replyExtremum.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.replyExtremum.minVal +
              "~" +
              this.rangeValData.replyExtremum.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateIdleReplyMaxTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.replyExtremum.minVal ||
        value > this.rangeValData.replyExtremum.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.replyExtremum.minVal +
              "~" +
              this.rangeValData.replyExtremum.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateIdleOpenedFirstReplyTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (
        !Number.isInteger(value) ||
        value < this.rangeValData.openedFirstReplyTime.minVal ||
        value > this.rangeValData.openedFirstReplyTime.maxVal
      ) {
        callback(
          new Error(
            "请输入" +
              this.rangeValData.openedFirstReplyTime.minVal +
              "~" +
              this.rangeValData.openedFirstReplyTime.maxVal +
              "的正整数"
          )
        );
      } else {
        callback();
      }
    };

    var validateIdleNomouthFixedReplyTimeList = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (value.indexOf("，") != "-1") {
        callback(new Error("数字之间请用英文逗号隔开"));
      } else {
        callback();
      }
    };
    // nomouthFixedReplyTimeList: [{
    // 	validator: validateIdleNomouthFixedReplyTimeList,
    // 	trigger: 'change'
    // }],

    // var validateIdleCheckCycleTime = (rule, value, callback) => {
    // 	if (value == '') {
    // 		callback(new Error("该配置不能为空"))
    // 	} else if (!Number.isInteger(value) || value < 0) {
    // 		callback(new Error("请输入正整数"))
    // 	} else {
    // 		callback()
    // 	}
    // }

    // var validatePollingTime = (rule, value, callback) => {
    // 	if (value == '') {
    // 		callback(new Error("该配置不能为空"))
    // 	} else if (!Number.isInteger(value) || value < 0) {
    // 		callback(new Error("请输入正整数"))
    // 	} else {
    // 		callback()
    // 	}
    // }

    return {
      form: {
        firstReplyTime: 3,
        typewriteTime: 200,
        nomouthIdleTime: 8,
        nomouthIdleNum: 5,
        omouthIdleTime: 60,
        omouthIdleNum: 3,
        idleIncrementTime: 2,
        nomouthReplyTimeMode: "fixed",

        nomouthFixedReplyTime: 3,
        replyMinTime: 0,
        replyMaxTime: 0,
        noopenFixedReply: "enable",
        nomouthFixedReplyTimeList: "2,3,7,10,13,16",
        utterReplyMode: "order",
        openedFirstReplyTime: 0,
        allocateBeforeOpening: false,

        // idleCheckCycleTime: '',
        // pollingTime: '',
      },
      formRules: {
        firstReplyTime: [
          {
            validator: validateFirstReplyTime,
            trigger: "change",
          },
        ],

        typewriteTime: [
          {
            validator: validateTypewriteTime,
            trigger: "change",
          },
        ],
        nomouthIdleTime: [
          {
            validator: validatenomouthIdleTime,
            trigger: "change",
          },
        ],
        nomouthIdleNum: [
          {
            validator: validateNomouthIdleNum,
            trigger: "change",
          },
        ],
        omouthIdleTime: [
          {
            validator: validateOmouthIdleTime,
            trigger: "change",
          },
        ],
        omouthIdleNum: [
          {
            validator: validateOmouthIdleNum,
            trigger: "change",
          },
        ],

        idleIncrementTime: [
          {
            validator: validateIdleIncrementTime,
            trigger: "change",
          },
        ],

        nomouthFixedReplyTime: [
          {
            validator: validateNomouthFixedReplyTime,
            trigger: "change",
          },
        ],
        replyMinTime: [
          {
            validator: validateIdleReplyMinTime,
            trigger: "change",
          },
        ],
        replyMinTreplyMaxTimeime: [
          {
            validator: validateIdleReplyMaxTime,
            trigger: "change",
          },
        ],
        nomouthFixedReplyTimeList: [
          {
            validator: validateIdleNomouthFixedReplyTimeList,
            trigger: "change",
          },
        ],

        openedFirstReplyTime: [
          {
            validator: validateIdleOpenedFirstReplyTime,
            trigger: "change",
          },
        ],

        // idleCheckCycleTime: [{
        // 	validator: validateIdleCheckCycleTime,
        // 	trigger: 'change'
        // }],
        // pollingTime: [{
        // 	validator: validatePollingTime,
        // 	trigger: 'change'
        // }],
      },
      departmentList: [],
      department: 1,
      rangeValData: {
        firstReplyTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        typewriteTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        nomouthIdleTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        nomouthIdleNum: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        omouthIdleTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        omouthIdleNum: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        idleIncrementTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        nomouthReplyTimeMode: {
          defVal: {
            name: "固定模式",
            value: "fixed",
          },
          vals: [
            {
              name: "固定模式",
              value: "fixed",
            },
            {
              name: "打字计算模式",
              value: "typewrite",
            },
          ],
        },
        nomouthFixedReplyTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        replyExtremum: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
        noopenFixedReply: {
          defVal: {
            name: "启用",
            value: "enable",
          },
          vals: [
            {
              name: "启用",
              value: "enable",
            },
            {
              name: "禁用",
              value: "disable",
            },
          ],
        },
        nomouthFixedReplyTimeList: [2, 7, 10, 13, 16],
        utterReplyMode: {
          defVal: {
            name: "顺序",
            value: "order",
          },
          vals: [
            {
              name: "顺序",
              value: "order",
            },
            {
              name: "随机",
              value: "random",
            },
          ],
        },
        openedFirstReplyTime: {
          defVal: 0,
          minVal: 0,
          maxVal: 0,
        },
      },
    };
  },

  created() {
    this.getRuleRangeval();
    // this.getRulesRequest();
    this.$nextTick(() => {
      setTimeout(() => {
        this.getRulesRequest();
      }, 1000);
    });
  },
  mounted() {
    this.getDepartmentList();
    // if
    // if (this.departmentList.length > 0) {
    // 	 this.getRulesRequest();
    //   this.getRuleRangeval();
    // }
  },
  methods: {
    async getRulesRequest() {
      var api = "/manager/devops/mm/mgr/get/rule/" + this.department;
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (response.resultCode == 10000) {
        if (response.data == null) {
          this.$message.success("该科室无默认规则，请选择其他科室进行配置");
        } else {
          response.data.nomouthFixedReplyTimeList = String(
            response.data.nomouthFixedReplyTimeList
          );
          this.form = response.data;
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    setRulesRequest(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          this.submitData();
        } else {
          this.$message.error("请注意查看配置信息是否正确!");
          return false;
        }
      });
    },

    async submitData() {
      let list1 = this.form.nomouthFixedReplyTimeList
        .replace(/\s*/g, "")
        .split(",");

      for (let i = 0; i < list1.length; i++) {
        list1[i] = parseInt(list1[i]);
      }
      console.log(list1);
      // this.form.nomouthFixedReplyTimeList = this.form.nomouthFixedReplyTimeList.replace(/\s*/g,"").split(',')
      var api = "/manager/devops/mm/mgr/set/rule";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          firstReplyTime: this.form.firstReplyTime,
          typewriteTime: this.form.typewriteTime,
          nomouthIdleTime: this.form.nomouthIdleTime,
          nomouthIdleNum: this.form.nomouthIdleNum,
          omouthIdleTime: this.form.omouthIdleTime,
          omouthIdleNum: this.form.omouthIdleNum,
          idleIncrementTime: this.form.idleIncrementTime,
          nomouthReplyTimeMode: this.form.nomouthReplyTimeMode,

          nomouthFixedReplyTime: this.form.nomouthFixedReplyTime,
          replyMinTime: this.form.replyMinTime,
          replyMaxTime: this.form.replyMaxTime,
          noopenFixedReply: this.form.noopenFixedReply,
          nomouthFixedReplyTimeList: list1,
          utterReplyMode: this.form.utterReplyMode,
          openedFirstReplyTime: this.form.openedFirstReplyTime,
          hospdepId: this.department,
        },
      });
      if (response.resultCode != 10000) {
        this.$message.error(response.desc);
      } else {
        this.$message.success("修改配置成功!");
      }
    },
    // 获取科室列表
    async getDepartmentList() {
      var api = "/manager/devops/syncUtter/getDepType";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("*****querySelect getDepType*****", response);
      this.departmentList = response.data;
      console.log("*****  this.departmentList*****", this.departmentList);
      if (this.departmentList.length > 0) {
        this.department = this.departmentList[0].depType;
        this.$nextTick(() => {
          this.changeDep();
        });
      }
    },

    //选择科室
    changeDep(val) {
      console.log("科室列表：", val);
      this.getRulesRequest();
      this.getRuleRangeval();
    },
    async getRuleRangeval() {
      var api = "/manager/devops/mm/mgr/get/rule/rangeval/" + this.department;
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("*****querySelect getRuleRangeval*****", response);
      if (response.resultCode == 10000) {
        // for(let key in response.data){

        // 	if(response.data[key] != null && response.data[key] != undefined){
        // 		this.form[key] = response.data[key].defVal
        // 	}
        // }
        this.rangeValData = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style scoped="scoped"></style>
